import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@mulesoft/anypoint-components/lib/Tooltip';
import Icon from '@mulesoft/anypoint-icons/lib/Icon';
import { getRunStatusByKey, RunStatusEnum } from '../../../types/commonTypes';
import styles from './StatusRun.css';

const StatusRun = React.memo(({ status, statusDetail, isDisabled = false }) => {
  if (!status) {
    // If status is null, show a dash
    return (
      <div data-test-id="status-run-id" className={styles.statusRunUnknown}>
        -
      </div>
    );
  }
  const statusRunInfo = getRunStatusByKey(status);

  const statusDiv = (
    <div
      data-test-id="status-run-id"
      className={styles[statusRunInfo.cssStyle]}
    >
      <span className={isDisabled ? styles.disabled : ''}>
        {statusRunInfo.label}
      </span>
    </div>
  );

  // Special case: if status is PARTIALSUCCES and statusDetail is not empty,
  // wrap in tooltip showing the detail
  if (statusRunInfo.key === RunStatusEnum.PARTIAL_SUCCESS.key && statusDetail) {
    return (
      <div data-test-id="status-run-id">
        <Icon name="warning-small" size={18} className={styles.warningIcon} />
        <Tooltip
          content={statusDetail}
          position="top"
          testId="status-run-tooltip"
        >
          <span className={isDisabled ? styles.disabled : ''}>
            {statusRunInfo.label}
          </span>
          <Icon name="info-small" size={18} className={styles.infoIcon} />
        </Tooltip>
      </div>
    );
  }
  // Special case: if status is FAILED, CAPACITY_EXCEEDED, or UNKNOWN
  // and statusDetail is not empty, wrap in tooltip showing the detail
  if (
    (statusRunInfo.key === RunStatusEnum.FAILED.key ||
      statusRunInfo.key === RunStatusEnum.CAPACITY_EXCEEDED.key ||
      statusRunInfo.key === RunStatusEnum.UNKNOWN.key) &&
    statusDetail
  ) {
    return (
      <div data-test-id="status-run-id">
        <Icon name="error" size={18} className={styles.errorIcon} />
        <Tooltip
          content={statusDetail}
          position="top"
          testId="status-run-tooltip"
        >
          <span className={isDisabled ? styles.disabled : ''}>
            {statusRunInfo.label}
          </span>
          <Icon name="info-small" size={18} className={styles.infoIcon} />
        </Tooltip>
      </div>
    );
  }

  // Special case: if status is UNKNOWN, wrap in tooltip showing the original status value
  if (statusRunInfo.key === RunStatusEnum.UNKNOWN.key) {
    return (
      <Tooltip
        content={`Unknown status: ${status}`}
        position="top"
        testId="status-run-unknown-tooltip"
      >
        {statusDiv}
      </Tooltip>
    );
  }

  return statusDiv;
});

StatusRun.propTypes = {
  status: PropTypes.string,
  statusDetail: PropTypes.string,
  isDisabled: PropTypes.bool
};

export default StatusRun;
